
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BrainCircuit, ShoppingBag, LineChart, Users, Shield, Zap } from "lucide-react";

const Features = () => {
  return (
    <section id="features" className="section bg-gradient-to-b from-violet-50 to-wallpaper-lightGray/40">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="wallpaper-subtitle text-3xl md:text-4xl lg:text-5xl mb-6">
            Älykkäät ominaisuudet <span className="font-wallpaper-serif italic bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">Verkkokaupoille</span>
          </h2>
          <p className="text-wallpaper-gray max-w-2xl mx-auto font-wallpaper text-lg">
            Tekoälyalustamme on huolellisesti suunniteltu vastaamaan modernien verkkokauppojen 
            ainutlaatuisiin haasteisiin ja mahdollisuuksiin.
          </p>
        </div>

        <div className="elegant-grid">
          <FeatureCard
            icon={<BrainCircuit size={28} className="text-purple-500" />}
            title="Älykkäät tuotesuositukset"
            description="Älykäs tuotesuosittelu asiakkaiden mieltymysten ja kattavan tuotetuntemuksen perusteella."
            bgColor="bg-purple-50"
            borderColor="border-l-4 border-l-purple-400"
          />
          <FeatureCard
            icon={<ShoppingBag size={28} className="text-pink-500" />}
            title="Varastonhallinta"
            description="Ennakoiva varastonhallinta optimaalisten varastotasojen ylläpitämiseksi."
            bgColor="bg-pink-50"
            borderColor="border-l-4 border-l-pink-400"
          />
          <FeatureCard
            icon={<LineChart size={28} className="text-blue-500" />}
            title="Myyntiennusteet"
            description="Tarkat ennusteet tuotteiden kysynnästä historiallisen datan ja markkinatrendien perusteella."
            bgColor="bg-blue-50"
            borderColor="border-l-4 border-l-blue-400"
          />
          <FeatureCard
            icon={<Users size={28} className="text-amber-500" />}
            title="Asiakasymmärrys"
            description="Syvällinen ymmärrys asiakkaiden mieltymyksistä ja käyttäytymisestä tuotteidesi kanssa."
            bgColor="bg-amber-50"
            borderColor="border-l-4 border-l-amber-400"
          />
          <FeatureCard
            icon={<Shield size={28} className="text-teal-500" />}
            title="Turvallinen toiminta"
            description="Yritystason tietoturva asiakas- ja yritystietojesi suojaamiseksi."
            bgColor="bg-teal-50"
            borderColor="border-l-4 border-l-teal-400"
          />
          <FeatureCard
            icon={<Zap size={28} className="text-indigo-500" />}
            title="Nopea käyttöönotto"
            description="Käyttöönotto päivissä, ei kuukausissa. Integroituu saumattomasti olemassa oleviin järjestelmiisi."
            bgColor="bg-indigo-50"
            borderColor="border-l-4 border-l-indigo-400"
          />
        </div>
      </div>
    </section>
  );
};

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  bgColor: string;
  borderColor: string;
}

const FeatureCard = ({ icon, title, description, bgColor, borderColor }: FeatureCardProps) => {
  return (
    <Card className={`luxury-card h-full border-none rounded-none bg-white shadow-md hover:shadow-lg transition-all ${borderColor}`}>
      <CardHeader className="pb-4">
        <div className={`${bgColor} w-14 h-14 flex items-center justify-center mb-6 rounded-md`}>
          {icon}
        </div>
        <CardTitle className="text-xl font-wallpaper font-normal">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription className="text-base text-wallpaper-gray font-wallpaper">{description}</CardDescription>
      </CardContent>
    </Card>
  );
};

export default Features;
